import React from 'react'
import { useNavigate } from 'react-router-dom'

const PocketPortfolioLanding = () => {
  const navigate = useNavigate()

  // Pocket Portfolio features array
  const features = [
    {
      "title": "Real-Time Portfolio Tracking",
      "description": "See Your Portfolio Update Instantly - Get real-time pricing, daily changes, and total performance across all your accounts.",
      "icon": "📈"
    },
    {
      "title": "Multiple Portfolios",
      "description": "Organize All Your Accounts in One Place - Easily track separate portfolios or accounts with clear totals and individual performance.",
      "icon": "🗂️"
    },
    {
      "title": "Detailed Holdings & Gains",
      "description": "Understand Your Returns at a Glance - View cost basis, market value, realized and unrealized gains, and performance in dollars or percent.",
      "icon": "💰"
    },
    {
      "title": "Beautiful Historical Charts",
      "description": "Analyze Trends from 1 Day to 5 Years - Interactive charts show stock performance over daily, weekly, monthly, and multi-year time frames.",
      "icon": "📊"
    },
    {
      "title": "Key Stock Fundamentals",
      "description": "Essential Financial Metrics at Your Fingertips - See earnings, market cap, P/E ratios, moving averages, and other important indicators.",
      "icon": "📚"
    },
    {
      "title": "Privacy-First Design",
      "description": "Your Data Never Leaves Your Device - No accounts, no tracking, and no servers — your entire portfolio stays private on your iPhone.",
      "icon": "🔒"
    }
  ]

  return (
    <div style={{ 
      width: '100%', 
      minHeight: '100vh',
      fontFamily: 'system-ui, sans-serif',
      color: '#2a2a2a',
      background: 'linear-gradient(135deg, #008B8B 0%, #006B6B 100%)'
    }}>
      {/* Header */}
      <header style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem 2rem',
        color: 'white'
      }}>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            color: 'white',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          ← Back to Home
        </button>
      </header>

      {/* Hero Section */}
      <section style={{
        textAlign: 'center',
        padding: '4rem 2rem',
        color: 'white'
      }}>
        <div style={{
          marginBottom: '1rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <img 
            src="/pocket-portfolio/logo.png" 
            alt="Pocket Portfolio Logo" 
            style={{
              height: '100px',
              width: 'auto',
              borderRadius: '16px'
            }}
          />
        </div>
        <h1 style={{
          fontSize: window.innerWidth <= 768 ? '2.5rem' : '3.5rem',
          fontWeight: 'bold',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
          margin: '0 0 1rem 0'
        }}>
          Pocket Portfolio
        </h1>
        <p style={{
          fontSize: '1.2rem',
          marginBottom: '2rem',
          opacity: 0.9,
          maxWidth: '600px',
          margin: '0 auto 2rem auto'
        }}>
          Track your investments with realtime data, detailed charts, stock fundamentals and more
        </p>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            backgroundColor: 'white',
            color: '#008B8B',
            textDecoration: 'none',
            borderRadius: '8px',
            fontSize: '1rem',
            fontWeight: '600',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
            opacity: 0.9
          }}
        >
          <svg width="20" height="24" viewBox="0 0 20 24" fill="currentColor" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.02 15.25 3.24 7.59 9.03 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.15c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
          </svg>
          Coming soon to the Apple App Store
        </div>
      </section>

      {/* Features Section */}
      <section style={{
        padding: '4rem 2rem',
        backgroundColor: 'white',
        color: '#2a2a2a'
      }}>
        <h3 style={{
          textAlign: 'center',
          fontSize: '2.5rem',
          marginBottom: '3rem',
          color: '#008B8B'
        }}>
          Pocket Portfolio Features
        </h3>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {features.map((feature, index) => (
            <div key={index} style={{
              padding: '2rem',
              backgroundColor: '#f8f9fa',
              borderRadius: '12px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>{feature.icon}</div>
              <h4 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>{feature.title}</h4>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Support Section */}
      <section style={{
        padding: '4rem 2rem',
        backgroundColor: 'white',
        color: '#2a2a2a'
      }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: '2.5rem',
          marginBottom: '3rem',
          color: '#008B8B'
        }}>
          Support & Contact
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <div style={{
            padding: '2rem',
            backgroundColor: '#f8f9fa',
            borderRadius: '12px',
            textAlign: 'center'
          }}>
            <h4 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Email Support</h4>
            <p>Get help at signalpeaksw@outlook.com</p>
          </div>
          <div 
            onClick={() => window.open('/pocket-portfolio/support.html', '_blank')}
            style={{
              padding: '2rem',
              backgroundColor: '#f8f9fa',
              borderRadius: '12px',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)'
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <h4 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>FAQ & Support</h4>
            <p>Frequently asked questions and answers</p>
          </div>
          <div 
            onClick={() => navigate('/pocket-portfolio/help')}
            style={{
              padding: '2rem',
              backgroundColor: '#f8f9fa',
              borderRadius: '12px',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)'
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <h4 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Documentation</h4>
            <p>Comprehensive guides and tutorials</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        padding: '2rem',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '2rem',
          marginBottom: '1rem',
          flexWrap: 'wrap'
        }}>
          <a href="/pocket-portfolio/privacy.html" style={{
            color: 'white',
            textDecoration: 'none',
            opacity: 0.8
          }}>
            Privacy Policy
          </a>
          <a href="/pocket-portfolio/terms.html" style={{
            color: 'white',
            textDecoration: 'none',
            opacity: 0.8
          }}>
            Terms of Service
          </a>
          <a href="/pocket-portfolio/support.html" style={{
            color: 'white',
            textDecoration: 'none',
            opacity: 0.8
          }}>
            Support & FAQ
          </a>
          <a href="mailto:signalpeaksw@outlook.com" style={{
            color: 'white',
            textDecoration: 'none',
            opacity: 0.8
          }}>
            Contact
          </a>
        </div>
        <p style={{ opacity: 0.7, fontSize: '0.9rem' }}>
          &copy; {new Date().getFullYear()} Signal Peak Software. All rights reserved.
        </p>
      </footer>
    </div>
  )
}

export default PocketPortfolioLanding

